import { ORDER_SET_PRODUCT_ART } from './actionTypes'

export default function orderSetProductArt(payload) {
  return {
    type: ORDER_SET_PRODUCT_ART,
    payload,
  }
}
